import { Permission } from "../../admin-service-typescript-client";
export var generalRoutes = [
    // {
    //     route: "",
    //     name: "Home",
    //     requiredPermissions: [],
    // },
    {
        route: "stats",
        name: "Dashboard",
        requiredPermissions: []
    },
    {
        route: "stats/creatives",
        name: "Kampagnen",
        requiredPermissions: [],
        subitems: []
    },
    {
        route: "stats/locations",
        name: "Standorte",
        requiredPermissions: []
    },
    // {
    //     route: "app/campaigns",
    //     name: "Kampagnen",
    //     requiredPermissions: [
    //         Permission.ReadCampaigns,
    //         Permission.ReadContents,
    //         Permission.ReadOrganisations,
    //     ],
    // },
    // {
    //     route: "customers",
    //     name: "Kunden",
    //     requiredPermissions: [Permission.ReadOrganisations],
    // },
];
export var campaignRoutes = [
    // {
    //     route: "",
    //     name: "Home",
    //     requiredPermissions: [],
    // },
    {
        route: "manage/creatives",
        name: "Creatives",
        requiredPermissions: []
    },
    {
        route: "manage/approval",
        name: "Freigabe",
        requiredPermissions: []
    },
    {
        route: "manage/campaigns",
        name: "Kampagnen",
        requiredPermissions: [],
        subitems: []
    },
    // {
    //     route: "app/campaigns",
    //     name: "Kampagnen",
    //     requiredPermissions: [
    //         Permission.ReadCampaigns,
    //         Permission.ReadContents,
    //         Permission.ReadOrganisations,
    //     ],
    // },
    // {
    //     route: "customers",
    //     name: "Kunden",
    //     requiredPermissions: [Permission.ReadOrganisations],
    // },
];
export var toolsRoutes = [
    // {
    //     route: "tools/networkstatus",
    //     name: "Netzstatus",
    //     requiredPermissions: [],
    // },
    // {
    //     route: "tools/remoteaccess",
    //     name: "Fernwartung",
    //     requiredPermissions: [],
    // },
    {
        route: "tools/provision",
        name: "Provisionierung",
        requiredPermissions: [
            Permission.ReadNetwork,
            Permission.ReadLocation,
            Permission.CreatePlayer,
            Permission.ConfirmPlayer,
            Permission.ReadTag,
        ]
    },
    // {
    //     route: "tools/statistics",
    //     name: "Statistiken",
    //     requiredPermissions: [
    //         Permission.ReadNetwork,
    //         Permission.ReadLocation,
    //         Permission.CreatePlayer,
    //         Permission.ConfirmPlayer,
    //         Permission.ReadTag,
    //     ],
    // },
];
export var adminRoutes = [
    {
        route: "admin/organisations",
        name: "Organisationen",
        requiredPermissions: [Permission.AdministerOrganisation]
    },
    {
        route: "admin/users",
        name: "Nutzer",
        requiredPermissions: [Permission.CreateUser]
    },
    {
        route: "admin/networks",
        name: "Netzwerke",
        requiredPermissions: [Permission.UpdateNetwork]
    },
];
export var routesGroups = [
    {
        name: "Kampagnen",
        routes: campaignRoutes
    },
    {
        name: "Stats",
        routes: generalRoutes
    },
    {
        name: "Tools",
        routes: toolsRoutes
    },
    {
        name: "Admin",
        routes: adminRoutes
    },
];
export var eventbusUrl = "https://eventbus.dev.whizad.io/eventbus";
// export const eventbusUrl = "https://10.21.2.119:9000/eventbus";
export var LocalDateTimeFormat = "YYYY-MM-DDTHH:mm:ss";
export default routesGroups;
